import { render } from "./AdminEshopsContainer.vue?vue&type=template&id=0aab0c6a"
const script = {}

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__